import * as Yup from "yup";

export const companyObject = {
  ID: "",
  companyName: "",
  companyDirectorsName: "",
  companyAddress: "",
  companyContact: "",
  companyNatureBusiness: "",
  is_brand_verified: false,
};

export function objectFromFormData(formData, brandID, agencyID) {
  return {
    ...(!!brandID && { brand_id: parseInt(brandID) }),
    company_name: formData.companyName,
    contact_no: formData.companyContact,
    company_address: formData.companyAddress,
    director_name: formData.companyDirectorsName,
    nature_of_business: formData.companyNatureBusiness,
  };
}

export function objectFromResponseData(responseData) {
  return {
    is_brand_verified: responseData.is_brand_verified,
    brandID: responseData.brand_id,
    ID: responseData.id,
    getAgreement: responseData?.get_agreement,
    signAgreement: responseData?.sign_agreement,
    companyName: responseData.company_name,
    companyAddress: responseData.address,
    companyContact: responseData.contact_no,
    companyNatureBusiness: responseData.nature_of_business,
    companyDirectorsName: responseData.director_name,
    mandatoryDetailsSubmitted: responseData.mandatory_details_submitted,
  };
}

export const validationSchema = Yup.object().shape({
  companyName: Yup.string().required("Company Name is required"),
  companyAddress: Yup.string().required("Company Address is required"),
  companyContact: Yup.string("Company Contact cant not be empty")
    .matches(/^\d+$/, "It should contain number only")
    .length(10, "Contact number should be of 10 digits")
    .required("Contact Number is required")
    .typeError("Company Contact cant not be empty"),
  companyDirectorsName: Yup.string().required(
    "Company Director's Name is required"
  ),
});
